// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2cGsi","content":"styles_content__2V5Zo","checkbox":"styles_checkbox__3s72G","checkboxLabel":"styles_checkboxLabel__1iFh5"};